import { TFunction } from 'i18next';

enum KeyTypeEnum {
	PhysicalKey = 'PhysicalKey',
	SecurePhysicalKey = 'SecurePhysicalKey',
	VirtualKey = 'VirtualKey',
}

export function getKeyTypeLabel(keyType: KeyTypeEnum, t: TFunction) {
	switch (keyType) {
		case KeyTypeEnum.PhysicalKey:
			return t('key.types.physicalKey', { ns: 'entities' });
		case KeyTypeEnum.SecurePhysicalKey:
			return t('key.types.securePhysicalKey', { ns: 'entities' });
		case KeyTypeEnum.VirtualKey:
			return t('key.types.virtualKey', { ns: 'entities' });
	}
}

export default KeyTypeEnum;
